import React from 'react'
import Link from 'next/link'
import styled from 'styled-components'

import { Text } from '@/components/Text'

import { ColorsMap } from '@/utils/Theme'
import { ReviewType } from '@/static/Brands/data'

type Props = {
  review: ReviewType
}

const BrandReview = ({ review }: Props) => {
  return (
    <ReviewWrapper>
      {review.reviewer && (
        <>
          <Text textColor="primary" fontSize="l" fontWeight="bold">
            {review.reviewer.name}
          </Text>
          <Text mb="1rem">{review.reviewer.description}</Text>
        </>
      )}
      <Text textColor="black" textAlign="justify">
        <q>{review.content}</q>
      </Text>
      {review.source && (
        <>
          <Text mt='1rem'>Zverejnené na <Text as='a' fontWeight={600} href={review.source.link}>{review.source.name}</Text></Text>
        </>
      )}
    </ReviewWrapper>
  )
}

export default BrandReview

const ReviewWrapper = styled.div`
  background: ${ColorsMap.white};
  padding: 2rem;
`

const ReviewSource = styled.a`
  text-decoration: underline;
  color: ${ColorsMap.textDefault};
  word-break: break-word;
`
